import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import React, { useState } from 'react';
import SendIcon from '@material-ui/icons/Send';

export interface IMessageInputProps {
    handleCreateMessage: any;
    disabled?: boolean;
}
const useStyles = makeStyles(theme => ({
    divider: {
        height: 28,
        margin: 4,
        width: 1,
    },
    form: {
        display: 'flex',
        width: '100%',
    },
    iconButton: {
        padding: 10,
    },
    input: {
        flex: 1,
        marginLeft: 8,
    },
    root: {
        alignItems: 'center',
        display: 'flex',
        marginTop: theme.spacing(1),
        padding: '2px 4px',
        width: '100%',
    },
}));

export default function MessageInput({ disabled, handleCreateMessage }: IMessageInputProps) {
    const classes = useStyles();
    const [text, setText] = useState('');
    const handleSubmit = (evt: any) => {
        setText('');
        evt.preventDefault();
        handleCreateMessage(text);
    };
    return (
        <Paper className={classes.root}>
            <form className={classes.form} data-cy="MessageInput" onSubmit={handleSubmit}>
                <InputBase
                    className={classes.input}
                    id="Channel-message"
                    inputProps={{ 'aria-label': 'Enter your message' }}
                    onChange={evt => setText(evt.target.value)}
                    placeholder="Enter your message"
                    value={text}
                />

                <Divider className={classes.divider} />
                <IconButton
                    aria-label="Directions"
                    className={classes.iconButton}
                    color="primary"
                    data-cy="SendButton"
                    onClick={handleSubmit}
                >
                    <SendIcon />
                </IconButton>
            </form>
        </Paper>
    );
}
